import { onMounted, onBeforeUnmount } from "vue";

export default function useAnimationObserver() {
  let observer = null;
  let mutationObserver = null;

  // Animation handler
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      } else {
        entry.target.classList.remove("active");
      }
    });
  };

  // Initialize observer
  const initObserver = () => {
    const observerOptions = {
      root: null,
      rootMargin: "-10% 0px",
      threshold: 0,
    };

    observer = new IntersectionObserver(handleIntersection, observerOptions);

    // Observe existing elements
    document.querySelectorAll(".animate").forEach((el) => {
      observer.observe(el);
    });

    // Set up mutation observer for new elements
    mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList.contains("animate")) {
            observer.observe(node);
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // Clean up
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
  };

  onMounted(() => {
    initObserver();
  });

  onBeforeUnmount(() => {
    cleanup();
  });

  // Public method to re-run observation
  const reobserve = () => {
    cleanup();
    initObserver();
  };

  return { reobserve };
}
